// Utility for generating and copying privacy policy embed code

export function getPrivacyPolicyEmbedCode(companyId: string) {
  return `<script>const customerId = "${companyId}"</script>\n<script src="https://login.deiterate.com/js/external-js/epp/privacy-policy.js?customerId=${companyId}"></script>`;
}

export async function copyToClipboard(text: string) {
  if (navigator.clipboard) {
    try {
      await navigator.clipboard.writeText(text);
      return true;
    } catch (e) {
      // fallback below
    }
  }
  // Fallback for older browsers
  const textarea = document.createElement('textarea');
  textarea.value = text;
  textarea.setAttribute('readonly', '');
  textarea.style.position = 'absolute';
  textarea.style.left = '-9999px';
  document.body.appendChild(textarea);
  textarea.select();
  try {
    document.execCommand('copy');
    document.body.removeChild(textarea);
    return true;
  } catch (err) {
    document.body.removeChild(textarea);
    return false;
  }
}
